import type { AutomaticLogoutContext } from "../../../shared/auth";
import type { KioskBindingV1, KioskOperator } from "./kiosk-binding";

export function createAutomaticLogoutProperties(
  context: AutomaticLogoutContext,
  binding: KioskBindingV1 | null,
  operator: KioskOperator | null,
) {
  return {
    automatic_logout_reason: context.reason,
    trigger_operation: context.operation,
    http_status: context.status,
    staff_action_required: true,
    next_action: "hidden_staff_login",
    kiosk_installation_id: binding?.kioskInstallationId,
    store_key: binding?.storeKey,
    zone_id: binding?.zoneId,
    placement: binding?.placement,
    user_id: operator?.userId,
    user_full_name: operator?.fullName,
    configured_by_user_id: binding?.configuredBy?.userId,
    configured_by_user_full_name: binding?.configuredBy?.fullName,
  } as const;
}
